import {ExtensionAttribute} from "./ExtensionAttribute";
import {CustomerAddress} from "./CustomerAddress";

export class Customer{

     addresses : CustomerAddress[] = [];
     createdAt : string
     createdIn : string
     defaultBilling : string
     defaultShipping : string
     disableAutoGroupChange : number
     email : string
     extensionAttributes : ExtensionAttribute
     firstname : string
     groupId : number
     id : number
     lastname : string
     storeId : number
     updatedAt : string
     websiteId : number
     type : string

    
}
